import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/work-schedules',
    name: 'work-schedule',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/work-schedule/index.vue')
  }
]
